export const Resources = {
  BalanceReport: 'balance_report',
  ExpenseReport: 'expense_report',
  BankOperations: 'bank_operations/final_statuses',
  BankOperationsPendingStatuses: 'bank_operations/pending_statuses',
  RequestBankOperations: 'bank_operations',
  ApiClients: 'api_clients',
  Providers: 'providers',
  Merchants: 'merchants',
  Companies: 'companies',
  Methods: 'methods',
  MethodLogos: 'method_logos',
  WorkTeams: 'work_teams',
  UserActions: 'user_actions',
  ProviderAccounts: 'provider_accounts',
  Commissions: 'commissions',
  Users: 'users',
  Roles: 'roles',
  RoleCategories: 'role_categoriess',
  OrderAdjustmentsReport: 'order_adjustments_report',
  OrderManualCreate: 'order_manual_create',
  OrdersBulkUpdate: 'orders/bulk_update',
  CumulativeReport: 'cumulative_report',
  RefundChargebackReport: 'refund_chargeback_report',
  OrderProviderExternalErrors: 'order_provider_external_errors',
  OrderConversionChart: 'monitoring/order_conversion_chart',
  OrderMethods: 'order_methods',
  Orders: 'orders',
  OrdersReport: 'orders_report',
  OrderAdjustments: 'order_adjustments',
  CommissionRecalculationTasks: 'commission_recalculation_tasks',
  Gateways: 'gateways',
  GatewayDeactivationReasons: 'gateway_deactivation_reasons',
  GatewayDirections: 'gateway_directions',
  GatewayStatuses: 'gateway_statuses',
  Limits: 'limits',
  GatewayRules: 'gateway_rules',
  OrderConversion: 'monitoring/order_conversion',
  MonitoringSettings: 'monitoring_settingss',
  ExpenseTypes: 'expense_types',
  ExpenseArticles: 'expense_articles',
  ExpenseSubarticles: 'expense_subarticles',
  ImportFileStatuses: 'import_file_statuses',
  BankOperationRequestViews: 'bank_operation_request_views',
  Currencies: 'currencies',
  OrderStatuses: 'order_statuses',
  Transactions: 'transactions',
  Referrals: 'referrals',
  MerchantNotificationSettings: 'merchant_notification_settings',
  TransactionStatuses: 'transaction_statuses',
  TransactionTypes: 'transaction_types',
  MerchantReferences: 'merchant_references',
  CommissionRecalculationStatuses: 'commission_recalculation_statuses',
  OrderActionUrls: 'order_action_urls',
  OrderNotificationUrls: 'order_notification_urls',
  ApiBankOperationsFinalStatusesGetCollection: '_api_bank_operations/final_statuses_get_collection',
  OrderCustomDatas: 'order_custom_datas',
  OrderDisputes: 'order_disputes',
  OrderNotifications: 'order_notifications',
  OrderEvents: 'order_events',
  ConditionGroups: 'condition_groups',
  Expressions: 'expressions',
  ExpressionParams: 'expression_params',
  ComparisonOperators: 'comparison_operators',
  Countries: 'countries',
  AdjustmentStatuses: 'adjustment_statuses',
  AdjustmentTypes: 'adjustment_types',
  CommissionStatuses: 'commission_statuses',
  CommissionComments: 'commission_comments',
  CommissionCalculationMethods: 'commission_calculation_methods',
  NewOrderStatuses: 'new/order_statuses',
  MethodTypes: 'method_types',
  MerchantAccounts: 'merchant_accounts',
  UserEventTypes: 'user_event_types',
  Entities: 'entities',
  ExternalErrorCategories: 'external_error_categories',
  Directions: 'directions',
  OrderStatusHistories: 'order_status_histories',
  ProviderWhiteIpAddresses: 'provider_white_ip_addresses',
  MerchantAccesses: 'merchant_accesses',
  UploadFiles: 'upload_files',
  GatewayConversionSettings: 'gateway_conversion_settings',
  MerchantCredentials: 'merchant_credentials',
  UserEntityPermissions: 'user_entity_permissions',
  GatewayMethods: 'gateway_methods',
  GatewayPilotModeSchedules: 'gateway_pilot_mode_schedules',
  BankOperationStatuses: 'bank_operation_statuses',
  Mappings: 'mappings',
  Badges: 'badges',
  BankOperationTypes: 'bank_operation_types',
  ApiClientWhiteIpAddresses: 'api_client_white_ip_addresses',
  ApiKeys: 'api_keys',
  Presets: 'presets',
  ImportFiles: 'import_files',
  MerchantProviderSettings: 'merchant_provider_settingss',
  Dashboard: 'dashboard',
  Reconciliation: 'reconciliation',
  ReconciliationMerchants: 'reconciliation-options/merchants',
  OrderStatusReconciliation: 'order-status-reconciliation',
} as const;

export type Resource = (typeof Resources)[keyof typeof Resources];
